import { render, staticRenderFns } from "./CreateLeadSuccessDialog.vue?vue&type=template&id=5f2b304e&"
import script from "./CreateLeadSuccessDialog.vue?vue&type=script&lang=js&"
export * from "./CreateLeadSuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports